export const GET_CMS_CONTENT =
  'https://js.cdn.carauktion.ch/api/getWidgetContent';
export const GET_ADDITIONAL_INFO =
  'https://js.cdn.carauktion.ch/api/getAdditionalInfo';
export const POST_ADDITIONAL_INFO =
  'https://js.cdn.carauktion.ch/api/submitAdditionalInfo';
